import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="post-medium-hidden"
export default class extends Controller {
    static values = { id: Number, hidden: Boolean, removeOnHide: Boolean }

    toggle() {
        const nextHidden = !this.hiddenValue
        const csrfToken = document.querySelector("[name='csrf-token']").content

        fetch(`/media/${this.idValue}/hidden`, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({ hidden: nextHidden })
        }).then(response => {
            if (!response.ok) throw new Error(`Hidden update failed: ${response.status}`)
            if (nextHidden && this.removeOnHideValue) {
                this.element.closest(".group").remove()
            } else {
                window.location.reload()
            }
        }).catch(() => {
            window.toast("Couldn't update media visibility. Please try again.", { kind: "alert" })
        })
    }
}
